import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Login from '../components/Login'
import PlanningViewer from '../components/PlanningViewer'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: PlanningViewer
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/planning',
    component: PlanningViewer,
    props: true
  }
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const tokenFromCookie = Vue.$cookies.get('KC-TOKEN')

  // si je vais sur autre page que login et que j'ai un token issu du cookie
  // je compare le token du cookie avec celui du state
  if (to.name !== 'login') {
    if (tokenFromCookie != null) {
      const tokenFromState = store.getters['authentication/token']
      if (tokenFromCookie !== tokenFromState) {
        store.commit('authentication/setLoginSuccess', tokenFromCookie)
      }
      next()
    } else {
      store.dispatch('authentication/logout')
      next({ name: 'login' })
    }
  }

  // in case of the user change the url to /login
  if (to.name === 'login') {
    if (tokenFromCookie != null) {
      next('/')
    } else {
      next()
    }
  }
})

export default router
